import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_ADD_PASSPORT,
    REQUEST_LIST_PASSPORTS,
    REQUEST_REMOVE_PASSPORT,
    REQUEST_UPDATE_PASSPORT,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/domoMsgDefinitions";
import { DomoPassportHeader, DomoPassportID } from "userful-chronos-app-common-js/dist/models/integration/domo";
import "./domoMsgReciever";

export const requestListPassports = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_PASSPORTS);
};

export const requestAddPassport = (payload: DomoPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_PASSPORT, payload);
};

export const requestUpdatePassport = (payload: DomoPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT, payload);
};

export const requestRemovePassport = (payload: DomoPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_PASSPORT, payload);
};
